<template>
    <div class="mvt-saleproceeds-new">
        <div class="mvt-saleproceeds-header">
            <div class="grid-flow-row text-bold gap-0">
                <div class="f0">{{ $filters.formatPrice(netProceeds) }}</div>
                <div class="f3">Estimated profit</div>
                <button class="btn medium m-t-2" @click="openLead">Get Free Valuation</button>
                <form novalidate class="grid xs-grid-cols-1 sm-grid-cols-2 gap-2 m-t-3 form">
                    <div class="group">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="homeSalePrice">Home sale price</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="homeSalePrice" @input="updateFeesBasedPerc" v-model="price"/>
                            </div>
                        </mvtTextbox>
                    </div>
                    <div class="group">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="outstandingMortgage">Outstanding mortgage</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="outstandingMortgage" v-model="mortgage"/>
                            </div>
                        </mvtTextbox>
                    </div>
                </form>
            </div>
        </div>

        <mvtCollapse :isActive="false">
            <template v-slot:header="collapsible">
                <div class="flex f5">
                    <span class="text-brand">Closing Fees & Costs</span>
                    <span>{{ $filters.formatPrice(totalCosts) }}</span>
                </div>
            </template>
            <template v-slot:default>
                <form novalidate class="form grid xs-grid-cols-1 gap-2">
                    <div class="group merge">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="agentFee">Agent fee</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="agentFee" @input="updateAgentPerc" v-model="agentFee"/>
                            </div>
                        </mvtTextbox>
                        <mvtTextbox>
                            <div class="input right">
                                <mvtInputDecimalNumber v-model="agentPercent" @input="updateAgentFee" :aria-label="`Down payment rate`" :maxDecimalPlaces="2"/>
                                <b class="text-a">%</b>
                            </div>
                        </mvtTextbox>
                    </div>

                    <div class="group merge">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="closingCosts">Closing costs</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="closingCosts" @input="updateClosingPerc" v-model="closingCosts"/>
                            </div>
                        </mvtTextbox>
                        <mvtTextbox>
                            <div class="input right">
                                <mvtInputDecimalNumber v-model="closingPercent" @input="updateClosingCosts" :aria-label="`Down payment rate`" :maxDecimalPlaces="2"/>
                                <b class="text-a">%</b>
                            </div>
                        </mvtTextbox>
                    </div>

                    <div class="group merge">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="sellerConcessions">Seller concessions</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="sellerConcessions" @input="updateConcessionPerc" v-model="concessionFee"/>
                            </div>
                        </mvtTextbox>
                        <mvtTextbox>
                            <div class="input right">
                                <mvtInputDecimalNumber v-model="concessionPercent" @input="updateConcessionFee" :aria-label="`Down payment rate`" :maxDecimalPlaces="2"/>
                                <b class="text-a">%</b>
                            </div>
                        </mvtTextbox>
                    </div>
                    <div class="group merge">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="homePrepFee">Home prep and repairs</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="homePrepFee" @input="updateHomePrepPerc" v-model="homePrepFee"/>
                            </div>
                        </mvtTextbox>
                        <mvtTextbox>
                            <div class="input right">
                                <mvtInputDecimalNumber v-model="homeprepPercent" @input="updateHomePrepFee" :aria-label="`Down payment rate`" :maxDecimalPlaces="2"/>
                                <b class="text-a">%</b>
                            </div>
                        </mvtTextbox>
                    </div>

                    <div class="group merge">
                        <mvtTextbox>
                            <div class="input left">
                                <label for="storageFee">Moving and storage</label>
                                <b class="text-a">$</b>
                                <mvtInputNumber id="storageFee" @input="updateStoragePerc" v-model="storageFee"/>
                            </div>
                        </mvtTextbox>
                        <mvtTextbox>
                            <div class="input right">
                                <mvtInputDecimalNumber v-model="storagePercent" @input="updateStorageFee" :aria-label="`Down payment rate`" :maxDecimalPlaces="2"/>
                                <b class="text-a">%</b>
                            </div>
                        </mvtTextbox>
                    </div>
                </form>
            </template>
        </mvtCollapse>
    </div>
</template>

<script src="./mvt-saleproceedsnew.js"></script>

<style lang="scss">
@use "./mvt-saleproceedsnew.scss" as *;
</style>
